export var pluralize = function pluralize(count, noun) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "s";
  return "".concat(count, " ").concat(noun).concat(count !== 1 ? suffix : "");
};